(() => {
  if (customElements.get('vwr-policy')) return;
  class WarrantyPolicy extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.checks = [...this.querySelectorAll('[data-warranty-check]')];
      this.status = this.querySelector('[data-warranty-status]');
      this.count = this.querySelector('[data-warranty-count]');
      this.links = [...this.querySelectorAll('.vwr-contents a')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.status) this.status.hidden = false;
      this.updatePrepared(false);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-warranty-check]')) this.updatePrepared(true);
      }, {signal});
      this.addEventListener('click', event => {
        const link = event.target.closest('.vwr-contents a');
        if (link) this.markActive(link.hash.slice(1));
      }, {signal});
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.getAnimations({subtree:true}).forEach(animation => animation.cancel());
      }, {signal});
      const sections = [...this.querySelectorAll('[data-warranty-section]')];
      this.markActive(sections.some(section => '#' + section.id === location.hash) ? location.hash.slice(1) : sections[0]?.id);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const visible = entries.filter(entry => entry.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (visible[0]) this.markActive(visible[0].target.id);
        }, {rootMargin:'-12% 0px -58% 0px',threshold:0});
        sections.forEach(section => this.observer.observe(section));
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.ready = false; }
    markActive(id) {
      this.links.forEach(link => {
        if (link.hash === '#' + id) link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
    }
    updatePrepared(moving) {
      if (!this.status || !this.count) return;
      const count = this.checks.filter(check => check.checked).length;
      this.count.textContent = count;
      this.status.toggleAttribute('data-complete',count === this.checks.length && count > 0);
      if (moving && !this.motion.matches && this.status.animate) this.status.animate([{opacity:.45,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}],{duration:200,easing:'cubic-bezier(.16,1,.3,1)'});
    }
  }
  customElements.define('vwr-policy',WarrantyPolicy);
})();
